import { Checkbox as ChakraCheckbox, CheckboxProps } from '@chakra-ui/react'
import * as React from 'react'

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ ...rest }, ref) => (
    <ChakraCheckbox data-testid="form-component-checkbox" ref={ref} {...rest} />
  ),
)
